import PeriprocedureelBeleidEdoxaban from "../../../../src/client/lta-antistolling/periprocedureel-beleid-edoxaban.json";
import * as React from 'react';
export default {
  PeriprocedureelBeleidEdoxaban,
  React
};